import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const listStyle = css({
  maxWidth: 600,
  gap: theme.spacing(2),
  margin: theme.spacing(2, 0),
  '> div': {
    maxWidth: 300,
  },
});

export const listOptionStyle = css({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  borderRadius: theme.borderRadius.medium,
  boxSizing: 'border-box',
  border: `1px solid ${theme.colors.neutral20}`,
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  cursor: 'pointer',
  '&:last-child': {
    marginBottom: 0,
  },
  '&:hover, &[data-focused=true]': {
    backgroundColor: theme.colors.primary5,
    borderColor: theme.colors.primary50,
  },
  '> svg': { display: 'none' },
  '> span': {
    flex: 1,
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
  },
  '*': {
    cursor: 'pointer',
  },
});

export const emptyStateContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
});

export const responsiveImageStyle = css({
  width: '100%',
  minWidth: 150,
  maxWidth: 'min(200px, 50vw)',
  height: 'auto',
});

export const itemLabelStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});
